import { useEffect, useState } from 'react';
import CrossLink from 'src/components/atoms/CrossLink/CrossLink';

import {
  useProjectDataStore,
  useWindowWidthStore,
} from 'src/StoreDataProvider';

const CrossLinks: () => JSX.Element = () => {
  const { randomProjects } = useProjectDataStore();
  const windowState = useWindowWidthStore();
  const [slideInterval, setSlideInterval] =
    useState<ReturnType<typeof setInterval>>();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [intervalCall, setIntervalCall] = useState(false);

  const initSlideInterval = (): void => {
    clearInterval(slideInterval);
    setSlideInterval(
      setInterval(() => {
        setCurrentSlide(currentSlide =>
          currentSlide < randomProjects.length - 1 ? currentSlide + 1 : 0
        );
      }, 5000)
    );
  };

  useEffect(() => {
    if (randomProjects.length && !intervalCall) {
      setIntervalCall(true);
      initSlideInterval();
    }
  }, [randomProjects]);

  return (
    <>
      <div
        className={`crossLinks ${
          !windowState.isMobileView ? 'crosslinks-desktop' : 'crosslinks-mobile'
        }`}
      >
        {randomProjects.map((project, index) => {
          return !windowState.isMobileView ? (
            <CrossLink key={project.id} {...project} />
          ) : (
            index === currentSlide && (
              <div key={`${project.id}-dot`}>
                <CrossLink {...project} />
                <div className="dot">
                  {randomProjects.map((_, idx) => {
                    return (
                      <em
                        key={idx}
                        className={`icon-kreis-gefuellt ${
                          currentSlide === idx ? 'active' : ''
                        }`}
                        onClick={() => {
                          setCurrentSlide(idx);
                          initSlideInterval();
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            )
          );
        })}
      </div>
    </>
  );
};

export default CrossLinks;
